import type ServiceLevel from '~/types/ServiceLevel';

export interface JSONCarrier {
  id: string;
  image_filename?: string;
  is_manifestable?: boolean;
  is_manifestable_date_range?: boolean;
  is_refundable?: boolean;
  is_track_substatus_enabled?: boolean;
  live_base_url?: string;
  max_tracking_numbers_allowed?: number;
  name?: string;
  provider_token?: string;
  service_levels?: ServiceLevel[];
  test_base_url?: string;
  track_url?: string;
  updated_time?: Date;
}

type Carrier = {
  icon: string;
  id: string;
  img: string;
  img200: Maybe<string>;
  img260: Maybe<string>;
  imgTrademark?: string;
  isManifestable?: boolean;
  isManifestableDateRange?: boolean;
  name: string;
  providerToken: string;
};

const normalizeCarrierName = (name: string): string =>
  name.trim().replace(/\s+/g, '_').toLowerCase();

const extraFieldsFromJSON = (jsonCarrier: JSONCarrier) => {
  const serialized: Partial<Carrier> = {
    isManifestable: jsonCarrier.is_manifestable || false,
    isManifestableDateRange: jsonCarrier.is_manifestable_date_range || false,
    providerToken: jsonCarrier.provider_token,
  };

  return serialized;
};

export { extraFieldsFromJSON, normalizeCarrierName };

export default Carrier;
